<section class="main-content gloalSearch">
  <div class="container">
    <div class="titleBox">
      <h1>Search Here</h1>
      <h2>Find what you are looking for</h2>
    </div>

  </div>
  <div class="searchWrap">

    <form [formGroup]="searchForm">
      <input type="text" (keyup)="searchTerm.next($event)" (focus)="getRecentlySearched()" formControlName="search"
        placeholder="Search..." />
    </form>


  </div>

  <div class="searchHist d-block d-md" *ngIf="recentlySearchList?.length">
    <h3>Recent Searched</h3>

    <div class="d-flex align-items-center" *ngFor="let item of recentlySearchList"
      (click)="onHistorySelect(item.searchedText)">
      <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/clock.webp'" alt="Clock Icon | Luminous">
      <span>{{item?.searchedText}}</span>

      <img class="ms-auto"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/slantedArrow.webp'" alt="Slanted Arrow | Luminous">
    </div>

  </div>

  <div class="searchTabs d-flex justify-content-lg-center ">
    <span class="me-lg-5" [ngClass]="activeFilter == item.name ? 'active' : ''" *ngFor="let item of searchTabs"
      (click)="filterTab(item.name)">
      {{item.name}} ({{item.totalCount}})
    </span>
  </div>
  <div class="searchDataWrapper">
    <div *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!loading">
      <div id="noResult" *ngIf="noResult" class="text-center d-flex flex-column align-items-center">
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/globalSearch/no-searchResult.webp'" alt="No Result | Luminous">
        <span >No results found</span>
      </div>
      <div *ngIf="!noResult">
        <!-- Products -->
        <div class="products"
          *ngIf="searchResults && searchResults?.customerProductSearchResponse?.customerProductSearchResponse && searchResults?.customerProductSearchResponse?.customerProductSearchResponse.length">
          <div class="container">
            <h3 class="text-uppercase">Products
              <span class="d-none d-md-inline">({{searchResults?.customerProductSearchResponse?.totalCount}})</span>
            </h3>
            <div class="row gx-lg-5 gy-lg-5">
              <div class="col-md-6 col-lg-4"
                *ngFor="let prodData of filteredProducts">
                <div class="product-col" (click)="routeToProduct(prodData.guidId,prodData.productName)">
                  <picture>
                    <img loading="lazy" [src]="prodData?.featureImageFileUrl" [alt]="prodData?.featureImageAltTag">
                  </picture>
                  <div class="description d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-transform-none">{{prodData?.productName}}</h4>
                      <p class="text-transform-none">{{prodData?.categoryName}}</p>
                    </div>
                    <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/back-icon.svg'" alt="Right Arrow | Luminous">
                  </div>
                </div>
              </div>

              <span class="showAllProd" (click)="filterTab('Products')"
                *ngIf="searchResults?.customerProductSearchResponse?.customerProductSearchResponse.length>3 && activeFilter !== 'Products'">
                Show all products <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/carbon_chevron-sort-down.svg'" alt="Right Arrow | Luminous">
              </span>

            </div>
          </div>
        </div>
        <!-- Categories -->
        <div class="categories"
          *ngIf="searchResults?.customerCategorySearchResponse && searchResults?.customerCategorySearchResponse?.totalCount">
          <div class="container">
            <h3 class="text-uppercase">Categories<span
                class="d-none d-md-inline">({{searchResults?.customerCategorySearchResponse?.totalCount}})</span></h3>
            <div class="row gx-lg-5 gy-lg-5">
              <div class="col-md-4 col-lg-3"
                *ngFor="let categData of filteredCategories">
                <div class="categ-col" (click)="categoryClickHandler(categData)">
                  <picture>
                    <img loading="lazy" [src]="categData.featureImageFileUrl ? categData.featureImageFileUrl : ''"
                    (error)="onImageError($event)" [alt]="categData?.featureImageAltTag"
                      role="button">
                  </picture>
                  <div class="description">
                    <h4 class="text-transform-none" role="button">{{categData?.name}}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="searchResults?.customerCategorySearchResponse?.customerCategorySearchResponse.length>4 && activeFilter !== 'Categories'">
              <span class="showAllProd" (click)="filterTab('Categories')">
                Show all categories <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/carbon_chevron-sort-down.svg'" alt="Right Arrow | Luminous">
              </span>
            </div>
          </div>
        </div>

        <!-- Catalogue -->
        <div class="catalog"
          *ngIf="searchResults?.customerCatalougesSearchResponse && searchResults?.customerCatalougesSearchResponse?.totalCount">
          <div class="container">
            <h3 class="text-uppercase">Catalogue <span
                class="d-none d-md-inline">({{searchResults?.customerCatalougesSearchResponse?.totalCount}})</span>
            </h3>
            <div class="row gx-lg-5 gy-lg-5">
              <div class="col-md-6 col-lg-6"
                *ngFor="let catalogData of filteredCatalogues">
                <div class="catalog-col" (click)="downloadCatalogue(catalogData?.catalogueFileUrl)">
                  <picture>
                    <img loading="lazy" [src]="catalogData?.catalogueImageFileUrl" [alt]="catalogData?.catalogueImageAltTag">
                  </picture>
                  <div class="description d-flex justify-content-between align-items-center">
                    <div class="d-flex w-100 align-items-center">
                      <h4>{{catalogData?.catalogueName}}</h4>
                      <a [href]="catalogData?.catalogueImageFileUrl" download>Download
                        <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/downloadBlue.webp'" alt="Download Icon | Luminous">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="searchResults?.customerCatalougesSearchResponse?.customerCatalougesSearchResponse.length>2 && activeFilter !== 'Catalogue'">
              <span class="showAllProd" (click)="filterTab('Catalogue')">
                Show all Catalogues <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/carbon_chevron-sort-down.svg'" alt="Right Arrow | Luminous">
              </span>
            </div>
          </div>
        </div>
        <div class="blogs"
          *ngIf="searchResults && searchResults.wordPressAllPostDetailsResponse && searchResults.wordPressAllPostDetailsResponse.wordPressPostResponses && searchResults && searchResults.wordPressAllPostDetailsResponse.wordPressPostResponses.length">
          <div class="container">
            <h3>Blogs<span class="d-none d-md-inline">
                ({{searchResults.wordPressAllPostDetailsResponse.wordPressPostResponses.length}})</span></h3>
            <app-carousal-page [genericCarousel]="true"
              [carouselSlideData]="searchResults.wordPressAllPostDetailsResponse.wordPressPostResponses">
            </app-carousal-page>
          </div>
        </div>
        <div class="watch-video"
          *ngIf="searchResults && searchResults.customerVideoSearchResponse && searchResults.customerVideoSearchResponse.customerVideoSearchResponse && searchResults && searchResults.customerVideoSearchResponse.customerVideoSearchResponse.length">
          <div class="container">
            <h3>Videos<span class="d-none d-md-inline">
                ({{searchResults.customerVideoSearchResponse.customerVideoSearchResponse.length}})</span></h3>
            <app-carousal-page [genericCarousel]="true"
              [carouselSlideData]="searchResults.customerVideoSearchResponse.customerVideoSearchResponse">
            </app-carousal-page>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
